import React, { useEffect, useRef } from 'react';
import {
    ConfigPageContainer,
    ContentContainer,
    ButtonContainer,
    StyledButton,
    Title,
    StyleButtonTheme,
} from './style-components';
//import scanQrCodeIcon from '@/assets/icons/scan-qr-code/scan-qr-code.svg';
import halfMoonIcon from '@/assets/icons/half-moon/half-moon.svg';
import privacyPolicyIcon from '@/assets/icons/privacy-policy/privacy-policy.svg';
import termsAndConditionsIcon from '@/assets/icons/terms-and-conditions/terms-and-conditions.svg';
import logOutIcon from '@/assets/icons/log-out/log-out.svg';
import { useNavigate } from 'react-router-dom';
import { Switch, Typography } from 'antd';
import { useTheme } from '@/contexts/theme-context/useThemeContext';
import palettes from '@/contexts/theme-context/config/palleteConfig';
import { amplitudeAddTrack, determineProjectName } from '@/utils/amplitud/event-track';
import { useUserContext } from '@/contexts/user/useUserContext';
import { WalletOutlined } from '@ant-design/icons';
import { formatAddress } from '@/utils/string/format';
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';

const ConfigurationPage: React.FC = () => {
    const { user, logout } = useUserContext();
    const address = user?.main_key ?? '';
    const navigate = useNavigate();
    const { theme, setTheme } = useTheme();

    /*const handleQRScan = () => {
        navigate('/scanner');
    };*/
    const scanExplorerUrl = import.meta.env.VITE_SCAN_EXPLORER_URL;
    const handleGoScanExplorer = () => {
        if (scanExplorerUrl && address) {
            window.open(`${scanExplorerUrl}/address/${String(address).toLowerCase()}`, '_blank');
        }
    };

    const handleTermsAndConditions = () => {
        amplitudeAddTrack(determineProjectName('Terms and Conditions'), {
            timestamp: new Date().toISOString(),
        });
        navigate('/terms-and-conditions');
    };

    const handlePrivacyPolicy = () => {
        amplitudeAddTrack(determineProjectName('Privacy Policy'), {
            timestamp: new Date().toISOString(),
        });
        navigate('/privacy-policy');
    };

    const firstRenderAmplitude = useRef<boolean>(true);
    useEffect(() => {
        if (firstRenderAmplitude.current) {
            firstRenderAmplitude.current = false;
            amplitudeAddTrack(determineProjectName(`Configuración`), {
                title: determineProjectName(`Configuración`),
            })
        }
    }, []);

    return (
        <ConfigPageContainer>
            <SEOHelmet
                metadata={{
                    title: determineProjectName(`Configuración`),
                    description: determineProjectName(`Configuración`)
                }}
            />
            <ContentContainer>
                <ButtonContainer>
                    <hr />
                    <Title>
                        Configuración
                    </Title>
                    <StyledButton
                        type="default"
                        icon={<WalletOutlined />}
                        onClick={handleGoScanExplorer}
                    >
                        {formatAddress(address)?.toLowerCase()}
                    </StyledButton>
                    {/*<StyledButton
                        type="default"
                        icon={<img src={scanQrCodeIcon} alt="Scan QR Code" />}
                        onClick={handleQRScan}
                    >
                        Escanear QR
                    </StyledButton>*/}
                    <StyleButtonTheme>
                        <StyledButton
                            type="default"
                            className="button-theme"
                            icon={<img src={halfMoonIcon} alt="Scan QR Code" />}
                        >
                            Modo obscuro
                        </StyledButton>
                        <Switch
                            checked={theme === palettes.dark}
                            onChange={setTheme}
                            style={{
                                marginLeft: "auto"
                            }}
                        />
                    </StyleButtonTheme>
                    <StyledButton
                        type="default"
                        icon={<img src={termsAndConditionsIcon} alt="Terms and Conditions" />}
                        onClick={handleTermsAndConditions}
                    >
                        Términos y Condiciones
                    </StyledButton>
                    <StyledButton
                        type="default"
                        icon={<img src={privacyPolicyIcon} alt="Privacy Policy" />}
                        onClick={handlePrivacyPolicy}
                    >
                        Política de Privacidad
                    </StyledButton>
                    <hr style={{ marginTop: "auto" }} />
                    <StyledButton
                        type="primary"
                        danger
                        icon={<img src={logOutIcon} alt="Log Out" />}
                        onClick={logout}
                    >
                        <Typography.Text>Cerrar sesión</Typography.Text>
                    </StyledButton>
                </ButtonContainer>
            </ContentContainer>
        </ConfigPageContainer>
    );
};

export default ConfigurationPage;
